
<p-dialog #tokenDialog header="New Version Available" [(visible)]="displayDialog" [modal]="true"
  [style]="{width: '600'}" [focusOnShow]="false">
  A new revision of the application is available. Please refresh your browser or reload using
  the button below to continue with this new version of the application.
  <div class="mt-3">
    <button i18n id="reload" class="btn btn-primary" (click)="refresh();">Reload</button>
  </div>
</p-dialog>

